import { ensureTrailingSlash } from './helpers';

export const thnkBasePath = new URL(window.location.origin);
export const pgPath = process.env.THNK_BASE_URL
  ? ensureTrailingSlash(process.env.THNK_BASE_URL)
  : '/';
export const pgBasePath = new URL(pgPath, thnkBasePath);

export const VERSION_CLIENT = process.env.VERSION || '';

export function convertUrl(url: string): string {
  if (process.env.THNK_REMOTE_DEBUG_IP) {
    return url.replace('127.0.0.1', process.env.THNK_REMOTE_DEBUG_IP);
  } else {
    return url;
  }
}

// The client-only engine no longer requires any server hosts. These remain only
// as optional base-URL prefixes for image-URL rewriting; they default to ''.
const pgServerHostEnv = process.env.THNK_PG_SERVER_HOST || '';
export const PG_SERVER_HOST = convertUrl(
  pgServerHostEnv.substring(pgServerHostEnv.length - 1, pgServerHostEnv.length) === '/'
    ? pgServerHostEnv.substring(0, pgServerHostEnv.length - 1)
    : pgServerHostEnv,
);

export const API_HOST = convertUrl(process.env.THNK_API_HOST || '');
